import { OrganizationChatSettings } from '@/store/user'

// Utility to clean up dirty markdown table content
export function cleanDirtyTableContent(v: string): string {
  let content = v
  if (typeof content !== 'string') return ''
  // Replace all instances of '--- |' preceded by a non-dash character
  content = content.replace(/([^-])--- \|/g, (_, p1) => `${p1}\n\n--- |`)

  // when finding the following pattern `| :--------------------- | :--------------------- |` in the content then we should find the third pipe on the left before this found pattern and add a new line before it
  // Find all positions to insert newlines
  const insertPositions: number[] = []
  content = content.replace(
    /(\| :[-]+ \| :[-]+ \|)/g,
    (match, _, offset: number, string: string) => {
      // Find the position of this match in the whole content
      const matchStart = offset
      // Count pipes to the left of the match
      let pipeCount = 0
      let thirdPipePos = -1
      for (let i = matchStart - 1; i >= 0; i--) {
        if (string[i] === '|') {
          pipeCount++
          if (pipeCount === 3) {
            thirdPipePos = i
            break
          }
        }
      }
      if (thirdPipePos !== -1) insertPositions.push(thirdPipePos)
      // If less than 3 pipes to the left, just return the match
      return match
    },
  )

  // Insert newlines at all found positions (reverse order to avoid index shift)
  insertPositions
    .sort((a, b) => b - a)
    .forEach((pos) => {
      if (pos === -1) return
      content = content.slice(0, pos) + '\n\n' + content.slice(pos)
    })

  // break lines between two pipes
  content = content.replace(/\|\|/g, '|\n|')

  return content
}

export const defaultBeneficiaryAppSettings = {
  colors: {
    '--color-gradient-start': [18, 71, 66],
    '--color-gradient-end': [150, 181, 175],
    '--color-highlight': '#FF664A',
    '--color-primary-default': '#124742',
    '--color-primary-50': '#EDF2F1',
    '--color-primary-100': '#DBE6E3',
    '--color-primary-200': '#BACFCA',
    '--color-primary-300': '#96B5AF',
    '--color-primary-400': '#759E95',
    '--color-primary-500': '#597F77',
    '--color-primary-600': '#47665F',
    '--color-primary-700': '#354B46',
    '--color-primary-800': '#124742',
    '--color-primary-900': '#0D3531',
    '--color-primary-950': '#092522',
  },
  imageUrl: '',
} satisfies OrganizationChatSettings

export function buildAnchorIdPrefix(itemId: string, field: string) {
  return `search-item-${itemId}-${field}`
}
export const buildAnchorId = (prefix: string, index: number) => `${prefix}-highlight-${index}`

export function downloadCSV(filename: string, csvContent: string) {
  // Create a blob
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

  // Create a link and click it
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
